import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import DepartmentSectionStyle3 from '../Section/DepartmentSection/DepartmentSectionStyle3';
import BannerSectionStyle6 from '../Section/BannerSection/BannerSectionStyle6';
import { pageTitle } from '../../helpers/PageTitle';
const departmentData = [
  {
    iconUrl: 'images/real/dept_ultrasound.png',
    title: 'Ultrasound',
    subTitle:
      'Safe, non-invasive imaging to examine internal organs, pregnancy, and soft tissues with accuracy.',
    href: '/tests/ultrasound',
  },
  {
    iconUrl: 'images/real/dept_xray.png',
    title: 'Digital X-Ray',
    subTitle:
      'Fast, low-radiation imaging for bones, chest, joints, and internal structures.',
    href: '/tests/digital-x-ray',
  },
  {
    iconUrl: 'images/real/dept_hematology.png',
    title: 'Hematology',
    subTitle:
      'Blood tests that assess hemoglobin, platelets, infections, and overall blood health.',
    href: '/tests/hemotology',
  },
  {
    iconUrl: 'images/real/dept_blood_profiles.png',
    title: 'Blood Profiles',
    subTitle:
      'Comprehensive health checkups covering sugar, cholesterol, liver, kidney, and heart risk in one report.',
    href: '/tests/blood-profiles',
  },
  {
    iconUrl: 'images/real/dept_clinical_pathology.png',
    title: 'Clinical Pathology',
    subTitle:
      'Routine tests like urine, stool, pregnancy, and semen analysis to detect common health issues early.',
    href: '/tests/clinical-pathology',
  },
  {
    iconUrl: 'images/real/dept_serology.png',
    title: 'Serology',
    subTitle:
      'Blood tests to detect infections such as dengue, typhoid, hepatitis, and immune conditions.',
    href: '/tests/serology',
  },
  {
    iconUrl: 'images/real/dept_surgical_profiles.png', // Fallback or specific surgical profile img if available
    title: 'Surgical Profiles',
    subTitle:
      'Essential pre-surgery tests to ensure the body is fit and safe for surgical procedures.',
    href: '/tests/surgical-profiles',
  },
  {
    iconUrl: 'images/real/dept_antenatal_profiles.png', // Fallback or specific antenatal img if available
    title: 'Antenatal Profiles',
    subTitle:
      'Important tests to monitor the health of both mother and baby during pregnancy.',
    href: '/tests/antenatal-profiles',
  },
  {
    iconUrl: 'images/real/dept_hormones.png',
    title: 'Hormones',
    subTitle:
      'Hormone testing to evaluate thyroid, fertility, growth, metabolism, and overall body balance.',
    href: '/tests/hormones',
  },
];

export default function Departments() {
  pageTitle('Departments');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/departments/Services.png"
        // imgUrl="/images/departments/banner_img.png"
        title="BRR DIAGNOSTICS"
        subTitle="Precision diagnostics for confident health decisions."
      />
      <Section bottomMd={140} bottomLg={100} bottomXl={60}>
        <DepartmentSectionStyle3 data={departmentData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle6
          imgUrl="/images/departments/banner_img_2.png"
          title="Don’t Let Your Health Take a Backseat!"
          subTitle="Schedule an appointment with one of our <br />experienced medical professionals today!"
        />
      </Section>
      {/* <br /> */}
    </>
  );
}
